module.exports = __webpack_public_path__ + "static/coding_bootcamp-8563519659503ec4bfd782bf158bee6a.jpeg";